// For use if a select needs two versions of placeholders/labels to fit
// better on smaller screens

import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";

import Select from "components/shared/Select";

const propTypes = {
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  largeSelectOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  smallSelectOptions: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string
};

const defaultProps = {
  largeSelectOptions: [],
  onChange: () => {},
  smallSelectOptions: [],
  value: null
};

const ResponsiveSelect = (props) => {
  const {
    inputId,
    inputName,
    largeSelectOptions,
    onChange,
    smallSelectOptions,
    value,
    ...selectProps
  } = props;

  const [inputValue, setInputValue] = useState(value);

  const onChangeValue = useCallback((selectedValue) => {
    setInputValue(selectedValue.value);
    onChange(selectedValue.value);
  });

  return (
    <>
      <Select
        {...selectProps}
        containerClassName="sm:tw-hidden select-container responsive-select-container-small"
        id={`${inputId}-small`}
        name={`${inputName}-small`}
        onChange={onChangeValue}
        options={smallSelectOptions}
        value={value}
      />
      <Select
        {...selectProps}
        containerClassName="tw-hidden sm:tw-block select-container responsive-select-container-large"
        id={`${inputId}-large`}
        name={`${inputName}-large`}
        onChange={onChangeValue}
        options={largeSelectOptions}
        value={value}
      />
      <input hidden id={inputId} name={inputName} defaultValue={inputValue} />
    </>
  );
};

ResponsiveSelect.propTypes = propTypes;
ResponsiveSelect.defaultProps = defaultProps;

export default ResponsiveSelect;
